import React, { useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useGridApiRef } from '@mui/x-data-grid';
import { listEmployees, unloadEmployees } from '../../../../modules/empModule/employees';
import EmployeeList from '../../../../components/common/form/modal/EmployeeList';
import EmpListBox from '../../../../components/common/form/modal/EmpListBox';
import * as yup from 'yup';
import { useFormik } from 'formik';
import EmpChkList from '../../../../components/common/form/modal/EmpChkList';


const EmpListContainer = ({ roleTyp, multi, handleClose, selectedEmployee }) => {
  const dispatch = useDispatch();

  const { employees, error, loading } = useSelector(
    ({ empModule, loading }) => ({
      employees: empModule.employees.employees,
      error: empModule.employees.error,
      loading: loading['employee/LIST_EMPLOYEES'],
    }),
  );

  const initialValues = {
    searchKeyword: 'usrNm',
    searchWords: '',
  };


  const validationSchema = yup.object({
    searchKeyword: yup.string('').nullable(),
    searchWords: yup.string('').trim().nullable(),
  });

  const formik = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: (values, { setSubmitting }) => {
      setSubmitting(true);

      let searchData = {
        "roleTypNm": roleTyp,
        "useYn": "Y",
        [values.searchKeyword]: values.searchWords,
      };


      setTimeout(() => {
        // alert(JSON.stringify(values, null, 2));
        dispatch(listEmployees(searchData));
        // formik.resetForm();
        setSubmitting(false);
      }, 1000);
    },
  });

  // 컴포넌트 마운트 후 list 데이터 요청
  useEffect(() => {
    dispatch(listEmployees({ "roleTypNm": roleTyp, "useYn": "Y" }));
    // console.log(employees,'employees')

    return () => {
      dispatch(unloadEmployees());
    };
  }, []);

  const apiRef = useGridApiRef();

  const columns = useMemo(
    () => [
      {
        field: 'id',
        headerName: 'ID',
        hide: true,
        type: 'string',
        editable: false,
      },
      {
        field: 'usrUuid',
        headerName: '사번',
        hide: true,
        type: 'string',
        editable: false,
      },
      {
        field: 'dptNm',
        headerName: '부서명',
        minWidth: 200,
        flex: 1,
        type: 'string',
        editable: false,
      },
      {
        field: 'usrNm',
        headerName: '이름',
        minWidth: 100,
        flex: 1,
        type: 'string',
        editable: false,
        align: 'left',
        headerAlign: 'left',
      },
      {
        field: 'gradeNm',
        headerName: '직급',
        minWidth: 100,
        flex: 1,
        type: 'string',
        editable: false,
        align: 'left',
        headerAlign: 'left',
      },
      {
        field: 'telNo',
        headerName: '연락처',
        minWidth: 120,
        flex: 0.6,
        type: 'string',
        editable: false,
      },
      {
        field: 'emlAddr',
        headerName: '이메일',
        minWidth: 200,
        flex: 1,
        type: 'string',
        editable: false,
      },

      // {
      //   field: 'gender',
      //   headerName: '성별',
      //   minWidth: 80,
      //   flex: 0.6,
      //   type: 'string',
      //   editable: false,
      //   align: 'center',
      //   headerAlign: 'center',
      //   renderCell: (params) => (
      //     (params.value === 'M') ? '남성' : '여성'
      //   )
      // }

    ],
    [],
  );

  const handleRowClick = (data) => {
    selectedEmployee(data.row);
    formik.resetForm();
    dispatch(listEmployees({ "roleTypNm": roleTyp, "useYn": "Y" }));
    handleClose();
  }

  const onSelectedRows = () => {
    const rowValues = Array.from(apiRef.current.getSelectedRows().values());
    selectedEmployee(rowValues);
    formik.resetForm();
    dispatch(listEmployees({ "roleTypNm": roleTyp, "useYn": "Y" }));
    handleClose();

  }


  return (
    <div>
      <EmpListBox formik={formik} multi={multi} onSelectedRows={onSelectedRows} />
      {multi ? (
        <EmpChkList
          apiRef={apiRef}
          columns={columns}
          rows={employees}
          error={error}
          loading={loading} 
          columnVisibilityModel={{
            id: false,
            usrUuid: false,
          }}
  
          />
      ) : (
        <EmployeeList
          apiRef={apiRef}
          columns={columns}
          rows={employees}
          error={error}
          loading={loading}
          handleRowClick={handleRowClick}
          columnVisibilityModel={{
            id: false,
            usrUuid: false,
          }}
  
        />
      )}

    </div>
  )
}

export default EmpListContainer